import { SidebarSection } from '@accure/ui';
import { CodeXml, FileText, Scale } from 'lucide-react';

import { Link } from '@/components/ui/link'; // still used for internal links
import { Tooltip } from '@/components/ui/tooltip';
import { env } from '@/env';

export function AppSidebarFooter() {
  const year = new Date().getFullYear();
  const version = env.VITE_WEBAPP_RELEASE.slice(0, 7);

  return (
    <SidebarSection className="mt-auto">
      <div className="flex justify-around px-2 py-1 text-xs text-gray-400">
        <Tooltip content="Changelog">
          <Link to="/changelog">
            <div className="flex size-8 items-center justify-center rounded-lg transition hover:bg-zinc-100 dark:hover:bg-white/10">
              <FileText className="size-4 hover:text-gray-600" />
            </div>
          </Link>
        </Tooltip>

        <Tooltip content="Legal Notice">
          <a
            href="https://www.accure.net/legal"
            target="_blank"
            rel="noreferrer"
            className="flex size-8 items-center justify-center rounded-lg transition hover:bg-zinc-100 dark:hover:bg-white/10"
          >
            <Scale className="size-4 hover:text-gray-600" />
          </a>
        </Tooltip>

        <Tooltip content={`Version ${version} © ${year}`}>
          <div className="flex size-8 cursor-default items-center justify-center rounded-lg transition hover:bg-zinc-100 dark:hover:bg-white/10">
            <CodeXml className="size-4 hover:text-gray-600" />
          </div>
        </Tooltip>
      </div>
    </SidebarSection>
  );
}
